import './index.scss';

import {inject, observer} from 'mobx-react';
import {Swiper, SwiperSlide} from 'swiper/react';
import Prevent from '../Prevent';
import {Pagination} from 'swiper';
import {jump} from '../../tools';

@inject(({store}) => {
    return {
        introductions: store.introductions
    };
})
@observer
class Introductions extends React.Component {
    render() {
        const {introductions} = this.props;
        if (!introductions.length) {
            return null;
        }
        return (
            <div className="introd">
                <img src="https://s.qunarzz.com/vacation_tuan/2023/abudhabi/title5.jpg"/>
                {
                    introductions.length && <Prevent>
                        <Swiper
                            pagination
                            loop={true}
                            modules={[Pagination]}
                        >
                            {
                                introductions.map((introd, sIndex) => {
                                    return (
                                        <SwiperSlide key={sIndex}>
                                            {
                                                introd && introd.map((item, index) => {
                                                    return <IntrodItem data={item} key={index} eIndex={(sIndex * 3 + index + 1) > 9 ? (sIndex * 3 + index + 1) : '0' + (sIndex * 3 + index + 1)} />;
                                                })
                                            }
                                        </SwiperSlide>
                                    );
                                })
                            }
                        </Swiper>
                    </Prevent>
                }
            </div>
        );
    }
}

const IntrodItem = (props) => {
    const {img = '', jumpInfo = {}, subTitle = '', title = ''} = props.data;
    const eIndex = props.eIndex;
    return (
        <div className="introd-item" key={props.key} data-sk-eid={`abu_gl_${eIndex}`}>
            <div className="left">
                <img src={img} />
            </div>
            <div className="right">
                <div className="title">
                    【{title}】
                </div>
                <div className="sub-title">
                    {subTitle}
                </div>
                <div className="btn" onClick={() => jump(jumpInfo)}>
                    查看完整攻略
                </div>
            </div>
        </div>
    );
};

export default Introductions;